/**
 * Dicionário canônico, em português — fonte da verdade para es.ts e en.ts.
 *
 * Acesso é por OBJETO (`t.login.titulo`), não por chave de string: dá
 * autocompletar, e uma chave renomeada quebra a compilação em todo lugar
 * que ainda a referencia, em vez de sumir silenciosamente em produção.
 *
 * Texto do SERVIDOR (mensagens de erro reais, itens da loja, prova, plano de
 * bandas) não mora aqui — só os textos fixos do cliente e os FALLBACKS que
 * aparecem antes de uma resposta do servidor chegar.
 */
export const pt = {
  app: {
    abaRadio: 'Rádio',
    abaGente: 'Gente',
    abaEstacao: 'Estação',
    abaProgresso: 'Progresso',
    abaAdmin: 'Admin',
    secoes: 'Seções',
    ouvinte: 'OUVINTE',
    classe: 'CLASSE',
    daProva: 'da prova',
    apelido: 'apelido',
    conectado: 'conectado',
    desconectado: 'desconectado',
    sair: 'sair',
    audioEstado: 'áudio',
    audioIniciando: 'iniciando…',
    tentarNovamente: 'tentar de novo',
    sinalEncontradoEm: 'Sinal encontrado em {freq} MHz.',
    varreduraCompleta: 'Varredura completa: nada encontrado nesta banda.',
    noCanal: 'No canal',
    ninguem: 'ninguém',
    noAr: 'NO AR',
    canalVazioPre: 'Ninguém nesta frequência. Veja em',
    canalVazioPos: 'onde tem movimento, ou marque um encontro.',
    ocultarMapa: 'Ocultar mapa',
    mapaDePropagacao: 'Mapa de propagação',
  },
  login: {
    titulo: 'Radioamador',
    confereEmail: 'Confira seu e-mail',
    modoDev: 'Modo desenvolvimento',
    modoDevTexto:
      'Este servidor não tem envio de e-mail, então o link veio na resposta da API. Em produção isso é login aberto e não pode existir.',
    entrarComLink: 'Entrar com o link',
    usarOutroEmail: 'usar outro e-mail',
    erroEnviarLink: 'não foi possível enviar o link',
    linkInvalido: 'link inválido',
    linkEnviado: 'Link enviado.',
    cadastroIntro:
      'Crie sua conta com e-mail e senha — sem precisar abrir e-mail nenhum agora. O e-mail só é usado de verdade se você esquecer a senha depois.',
    comoChamar: 'Como querem te chamar',
    apelidoPlaceholder: 'SEU APELIDO',
    cadastroHintPre: 'De 3 a 12 letras ou números.',
    cadastroHintForte: 'Não precisa ter indicativo',
    cadastroHintPos:
      'para entrar: com apelido você já conversa na Faixa do Cidadão (PX) e nos serviços abertos. Indicativo de radioamador vem depois — passando na nossa prova, ou comprovando a licença que você já tem na Anatel.',
    email: 'E-mail',
    emailPlaceholder: 'voce@exemplo.com',
    senha: 'Senha',
    confirmarSenha: 'Confirmar senha',
    criarConta: 'Criar conta',
    criando: 'criando…',
    jaTenhoConta: 'já tenho conta',
    senhasNaoConferem: 'as senhas não conferem',
    erroCriarConta: 'não foi possível criar a conta',
    erroServidor: 'não foi possível falar com o servidor',
    recuperarIntro:
      'Esqueceu a senha? Digite o e-mail cadastrado — mandamos um link para você entrar e trocar a senha.',
    receberLink: 'Receber link de acesso',
    enviando: 'enviando…',
    jaTenhoSenha: 'já tenho senha',
    loginLabel: 'Indicativo, apelido ou e-mail',
    entrar: 'Entrar',
    entrando: 'entrando…',
    naoTemConta: 'Não tem conta? Cadastre-se',
    esqueciSenha: 'Esqueci a senha',
    erroEntrar: 'não foi possível entrar',
    desafioInstrucao: 'Arraste até sintonizar a marca — é assim que a gente sabe que é você',
    desafioSintonizado: 'Sintonizado ✓',
    desafioCarregando: 'preparando o dial…',
    erroDesafio: 'não deu pra preparar a verificação — recarregue a página',
  },
  admin: {
    carregando: 'carregando…',
    pedidosTitulo: 'Pedidos de indicativo',
    semPedidos: 'Nenhum pedido pendente.',
    classe: 'classe',
    aprovar: 'aprovar',
    recusar: 'recusar',
    verDocumento: 'ver documento',
    comDocumento: 'com documento',
    semDocumento: 'sem documento',
    pedidosHint:
      'Aprovar adota o indicativo na conta e marca a licença como conferida. A documentação chega por e-mail e não fica guardada aqui.',
    contasTitulo: 'Contas',
    admin: 'ADMIN',
    loginBloqueado: 'LOGIN BLOQ.',
    txBloqueado: 'TX BLOQ.',
    ouvinte: 'ouvinte',
    comSenha: 'com senha',
    soLink: 'só link',
    voce: 'você',
    administra: 'administra',
    editar: 'editar',
    excluir: 'excluir',
    editarTitulo: 'Editar',
    swl: 'SWL (ouvinte)',
    classeC: 'Classe C',
    classeB: 'Classe B',
    classeA: 'Classe A',
    indicativoApelido: 'Indicativo/apelido',
    email: 'E-mail',
    redefinirSenha: 'Redefinir senha (deixe em branco pra não mexer)',
    bloquearLogin: 'Bloquear login — a pessoa não entra mais, de jeito nenhum',
    bloquearTx: 'Bloquear transmissão — continua entrando e ouvindo, só não transmite',
    edicaoHint:
      'Se a pessoa estiver conectada agora, o efeito é imediato — a conexão cai e ela reconecta sozinha já com o estado novo.',
    salvar: 'Salvar',
    cancelar: 'cancelar',
    excluirTitulo: 'Excluir',
    excluirAviso:
      'Vão junto, sem desfazer: logbook, créditos, compras, perfil de estação, encontros e pedidos de indicativo. A sessão da pessoa deixa de valer na hora.',
    digitePara: 'Digite',
    paraConfirmar: 'para confirmar',
    excluirDefinitivamente: 'Excluir definitivamente',
    erroListar: 'não foi possível listar as contas',
    erroExcluir: 'não foi possível excluir',
    excluida: 'foi excluída, com tudo que pendia dela.',
    erroServidor: 'não foi possível falar com o servidor',
    atualizada: 'foi atualizada.',
    erroSalvar: 'não foi possível salvar',
  },
  awards: {
    titulo: 'Diplomas',
    resumoIniciados: '{iniciados} de {total} iniciados',
    faltamContagem: 'faltam {n}',
    faltamLista: 'Faltam: {lista}',
    eMaisContagem: 'e mais {n}',
    completo: 'Completo',
    proximoTier: 'Próximo: {tier} — faltam {n}',
    feitosLista: 'Feitos: {lista}',
    nota:
      'Modo Claro e QSO importado entram no histórico, mas não contam para diploma — senão o troféu não significa nada.',
  },
  cwSender: {
    modoSimples: 'Simples',
    modoAvancado: 'Avançado',
    modoChave: 'Chave manual',
    transmitindoSolte: 'Transmitindo — solte para terminar o ponto ou traço',
    segureParaTransmitir: 'Segure para transmitir',
    noAr: 'NO AR',
    chave: 'CHAVE',
    velocidade: 'Velocidade:',
    palavrasPorMinuto: 'palavras por minuto — toque para trocar',
    finalizar: 'Finalizar',
    parar: 'Parar',
    placeholderAvancado: 'digite — cada letra já sai no ar',
    placeholderSimples: 'CQ CQ DE ...',
    enviar: 'Enviar',
    textoParaCW: 'Texto para mandar em CW',
    jeitoDeMandar: 'Jeito de mandar:',
    toqueParaTrocar: '— toque para trocar',
    semPrivilegio: 'sem privilégio nesta frequência',
    alfabetoMorse: 'Alfabeto Morse',
    enviado: 'Enviado:',
  },
  dock: {
    filtroLargo: 'Largo',
    filtroNormal: 'Normal',
    filtroEstreito: 'Estreito',
    filtroCW: 'CW',
    squelchDesligado: 'Desligado',
    squelchBaixo: 'Baixo',
    squelchMedio: 'Médio',
    squelchAlto: 'Alto',
    descer5: 'Descer 5 kHz',
    descerMeio: 'Descer meio kHz',
    subirMeio: 'Subir meio kHz',
    subir5: 'Subir 5 kHz',
    bandasAriaLabel: 'Bandas',
    canal: 'CANAL',
    modoLabel: 'Modo:',
    toqueParaTrocar: '— toque para trocar',
    filtroFI: 'Filtro de FI:',
    squelchLabel: 'Squelch:',
    sql: 'SQL',
    chiadoLigado: 'Chiado de banda ligado — toque para desligar e ouvir só a voz',
    audioLimpo: 'Áudio limpo, sem chiado — toque para religar o chiado de banda',
    chiado: 'Chiado',
    limpo: 'Limpo',
    parar: 'Parar',
    varrer: 'Varrer',
    semPrivilegio: 'sem privilégio nesta frequência',
    canalSilencioso: 'canal silencioso',
    sinalFraco: 'sinal fraco — antena, potência ou distância podem estar limitando. Ajuste em Estação.',
    escalaFrequenciaAria: 'Escala de frequência. Arraste para sintonizar.',
  },
  exam: {
    titulo: 'Exame Classe C',
    tecnicaEtica: 'Técnica e ética',
    legislacao: 'Legislação',
    eletronica: 'Eletrônica',
    examRule: 'Aprovação exige {n}% em CADA disciplina, não na média.',
    oQueVoceErrou: 'O que você errou',
    certa: 'Certa:',
    fazerOutraProva: 'Fazer outra prova',
    anterior: 'Anterior',
    proxima: 'Próxima',
    entregarProva: 'Entregar prova',
    respondidasContagem: '{respondidas} de {total} respondidas',
    introPre: 'Três disciplinas, 15 questões cada, nos moldes do COER. Aprovação exige acertar 8 de 15 em',
    introForte: 'cada',
    introPos: 'disciplina — não na média. Sem prova de telegrafia: a Res. 777/2025 aboliu o CW obrigatório.',
    iniciarProva: 'Iniciar prova',
    erroIniciar: 'não foi possível iniciar a prova',
  },
  gente: {
    agora: 'AGORA',
    ja: 'já',
    emMinutos: 'em {n} min',
    emHoras: 'em {n} h',
    emDia: 'em {n} dia',
    emDias: 'em {n} dias',
    noArAgora: 'No ar agora',
    vazio:
      'Ninguém no ar neste instante. Marque um encontro abaixo — é assim que o hobby resolve isso desde sempre: combina-se hora e frequência, e as duas pessoas aparecem.',
    noAr: 'no ar',
    noArPill: 'NO AR',
    encontrosMarcados: 'Encontros marcados',
    cancelar: 'cancelar',
    marcar: 'marcar',
    vazioEncontros:
      'Nada combinado ainda. Marcar um encontro é o jeito mais direto de transformar "tem alguém aí?" em conversa.',
    convida: 'convida ·',
    ninguemConfirmou: 'ninguém confirmou ainda',
    confirmados: 'confirmados',
    naoVouMais: 'Não vou mais',
    euVou: 'Eu vou',
    desmarcar: 'desmarcar',
    sobreOQue: 'Sobre o quê',
    placeholderTitulo: 'Bate-papo de sábado',
    frequencia: 'Frequência (kHz)',
    modo: 'Modo',
    quando: 'Quando',
    recado: 'Recado (opcional)',
    placeholderRecado: 'Quem for novato, apareça — a gente ajuda',
    marcarEncontro: 'Marcar encontro',
    marcando: 'marcando…',
    erroMarcar: 'não foi possível marcar',
  },
  identidade: {
    minhaIdentidade: 'Minha identidade',
    apelido: 'Apelido',
    indicativoDaProva: 'Indicativo da prova',
    indicativoOficial: 'Indicativo oficial',
    hintLivrePre: 'Com apelido você já fala na',
    hintLivreForte: 'Faixa do Cidadão (PX)',
    hintLivrePos:
      'e nos serviços abertos — ela não exige indicativo nem classe. Para as faixas de radioamador há dois caminhos: passar na nossa prova, que emite um indicativo aqui de dentro, ou comprovar a licença que você já tem.',
    hintSimulado:
      'Este indicativo foi emitido por nós e vale só aqui dentro: o prefixo tem três letras, forma que a UIT não emite, então ele nunca coincide com o de um radioamador de verdade. Nas faixas, vale o mesmo que um oficial da sua classe. Se você já tem indicativo próprio, dá para reservá-lo abaixo.',
    hintOficial:
      'Indicativo conferido com a licença apresentada. Para trocar de classe ou de indicativo, abra um novo pedido.',
    trocarSenha: 'Trocar a senha',
    definirSenha: 'Definir uma senha',
    senhaAtualPlaceholder: 'senha atual',
    novaSenhaPlaceholder: 'nova senha, 8 caracteres ou mais',
    senhaHint:
      'Com senha você entra direto, sem abrir o e-mail toda vez. O link continua funcionando — é por ele que se recupera senha esquecida.',
    trocarSenhaBotao: 'Trocar senha',
    definirSenhaBotao: 'Definir senha',
    removerSenha: 'remover a senha e voltar a entrar só por link',
    pedidoEmAnalise: 'Pedido em análise para',
    pedidoClasseTemplate: '(classe {classe})',
    pedidoMeio:
      'Nada muda até alguém conferir o documento — você continua operando como está agora.',
    enviarComprovacaoTemplate: 'Envie a comprovação para {contato}.',
    documentoLabel: 'Documento (foto ou PDF)',
    documentoJaEnviado: 'Documento já enviado — reenviar substitui o anterior.',
    documentoAindaNao: 'Nenhum documento enviado ainda.',
    enviarDocumentoBotao: 'Enviar documento',
    enviandoDocumento: 'enviando…',
    documentoEnviado: 'Documento enviado.',
    erroEnviarDocumento: 'não foi possível enviar o documento',
    indicativoOficialSeu: 'Indicativo oficial que é seu',
    callsignPlaceholder: 'PY2ABC',
    reservarHint:
      'Reservar é para o titular. Vamos pedir a licença ou o comprovante de COER com a classe ativa, no seu nome.',
    classeAtiva: 'Classe ativa',
    pedirReserva: 'Pedir reserva do indicativo',
    abrindo: 'abrindo…',
    naoGuardamos:
      'O documento, se enviado, é apagado automaticamente algum tempo depois da decisão — não fica guardado para sempre. Aqui fica só o pedido e o resultado.',
    erroAbrirPedido: 'não foi possível abrir o pedido',
    erroServidor: 'não foi possível falar com o servidor',
    erroGravar: 'não foi possível gravar',
    pronto: 'pronto',
    excluirContaToggle: 'Excluir minha conta',
    excluirContaAviso:
      'Vão junto, sem desfazer: logbook, créditos, compras, perfil de estação, encontros e pedidos de indicativo. Você sai na hora.',
    digiteSeuIndicativo: 'Digite',
    paraExcluirConta: 'para confirmar',
    excluirContaBotao: 'Excluir minha conta definitivamente',
    excluindoConta: 'excluindo…',
    erroExcluirConta: 'não foi possível excluir a conta',
  },
  instalarApp: {
    iosInstrucao: 'Instale: toque em Compartilhar e depois "Adicionar à Tela de Início".',
    outroInstrucao: 'Instale o app: tela cheia, sem a barra do navegador.',
    instalar: 'instalar',
    dispensar: 'dispensar',
  },
  logbook: {
    titulo: 'Logbook',
    qso: 'QSO',
    paises: 'países',
    bandas: 'bandas',
    pDiploma: 'p/ diploma',
    indicativoPlaceholder: 'INDICATIVO',
    indicativoAria: 'Indicativo da outra estação',
    rstEnviado: 'RST enviado',
    rstRecebido: 'RST recebido',
    gravar: 'Gravar',
    hintSufixo: 'banda, país e distância são preenchidos pelo servidor',
    jaHaContato: 'já há contato com esta estação hoje, nesta banda e modo',
    erroGravar: 'não foi possível gravar',
    claro: 'CLARO',
    exportarADIF: 'Exportar ADIF',
    exportarHint: 'sai marcado como simulado — não envie para LoTW ou eQSL',
  },
  mapView: {
    mapaIndisponivel: 'mapa indisponível:',
    dia: 'dia',
    noite: 'noite',
    greyLineAgora: 'GREY LINE agora',
    doSolEm: 'do sol em',
    min: 'min',
  },
  ptt: {
    transmitindoSolte: 'Transmitindo. Solte para ouvir.',
    segureParaFalar: 'Segure para falar',
    bipe: 'BIPE',
    noAr: 'NO AR',
    pttLabel: 'PTT',
    aguardeBipe: 'aguarde o bipe',
    desconectado: 'desconectado',
    semPrivilegio: 'sem privilégio aqui',
    toqueParaParar: 'toque para parar',
    solteParaOuvir: 'solte para ouvir',
    toqueParaFalar: 'toque para falar',
    segureParaFalar2: 'segure para falar',
    toque: 'toque',
    segurar: 'segurar',
    alternarTitle: 'Alterna entre segurar e tocar para transmitir',
  },
  shack: {
    titulo: 'Estação e créditos',
    creditos: 'créditos',
    semSeguidas: 'sem. seguidas',
    creditosDisponiveis: 'créditos disponíveis',
    deOndeVeio: 'de onde veio?',
    ocultarExtrato: 'ocultar extrato',
    sequenciaAtualSingular: 'Sequência atual: 1 semana seguida',
    sequenciaAtualPlural: 'Sequência atual: {n} semanas seguidas',
    semSequenciaSingular: 'Sem sequência agora — recorde: 1 semana',
    semSequenciaPlural: 'Sem sequência agora — recorde: {n} semanas',
    faltamParaBonus: 'faltam {n} para o próximo bônus',
    ledgerVazio: 'Nenhum crédito ainda. Faça um QSO.',
    eSeu: 'é seu.',
    erroComprar: 'não foi possível comprar',
    rig: 'Transceptores',
    antenna: 'Antenas',
    feedline: 'Cabos (rolo de 20 m)',
    amplifier: 'Amplificadores',
    rotator: 'Rotores',
    tower: 'Torres e mastros',
    filter: 'Filtros de FI',
    seu: 'SEU',
    cr: 'cr',
    nota:
      'Todo equipamento se obtém operando. Nada que afete desempenho de RF é vendido por dinheiro real — um ambiente onde quem paga é ouvido melhor destrói a premissa do hobby.',
  },
  station: {
    minhaEstacao: 'Minha estação',
    bipeRoger: 'Bipe ao soltar o PTT (roger)',
    bipeRogerHint:
      'Sai depois da sua última palavra, com o transmissor ainda ligado. Diz "acabei, pode falar" — em FM e na PX não há portadora audível, então sem ele ninguém sabe se você terminou ou só respirou.',
    bipeInicio: 'Bipe ao apertar o PTT',
    bipeInicioHint:
      'Avisa que sua fala vai começar. O microfone só abre DEPOIS do tom — o botão de PTT mostra a hora de falar.',
    ouvir: 'ouvir',
    ligueAudioPrevia: 'Ligue o áudio na aba Rádio para ouvir a prévia.',
    bipeHint:
      'O bipe é transmitido junto com a voz, então percorre o mesmo caminho de rádio: estação fraca tem bipe fraco.',
    transceptor: 'Transceptor',
    antena: 'Antena',
    rotor: 'Rotor',
    cabo: 'Cabo',
    filtroFI: 'Filtro de FI',
    nenhum: 'Nenhum',
    rotorHint: 'Pré-requisito pra equipar uma antena direcional (Yagi) — sem rotor, ela fica travada.',
    precisaRotor:
      'A antena escolhida precisa de rotor pra ser equipada. Compre um na loja ou volte pra uma antena sem essa exigência.',
    filtroHint: 'Sem acessório, o piso de largura é 500 Hz (ou o que o rádio já traz de fábrica).',
    alturaAntena: 'Altura da antena (m)',
    alturaHint:
      'Até {max} m com o que você tem hoje — sem torre, o teto é um mastro de telhado. Altura decide o ângulo de takeoff, não a potência.',
    torre: 'Torre',
    torreHint: 'Sem torre, o teto de altura é um mastro de telhado.',
    direcaoAntena: 'Direção da antena (graus, 0=Norte)',
    direcaoHint: 'Só importa pra antena direcional (Yagi) e pro dipolo (a orientação do fio).',
    comprimentoCabo: 'Comprimento do cabo (m)',
    caboHint: 'Cabo longo demais devolve em perda o que a antena ganhou.',
    potencia: 'Potência (W)',
    potenciaHint: 'Até {max} W com o que você tem hoje.',
    amplificador: 'Amplificador',
    amplificadorHint: 'Sem amplificador, o teto de potência é o que o próprio rádio entrega.',
    swr: 'SWR',
    swrHint: 'Casamento ruim vira perda no cabo.',
    ambienteQTH: 'Ambiente do QTH',
    ambienteHint:
      'Define o piso de ruído. Ouvir é mais difícil que falar — e o ambiente pesa mais que o rádio nessa conta.',
    locator: 'Locator (grid Maidenhead)',
    locatorHint:
      'Ex.: GG66oe. Um grid de 6 caracteres equivale a uma área de ~5×5 km — o bastante para o motor de propagação, sem expor seu endereço exato.',
    qthHint: 'Mudar de QTH tem carência de {h} h — senão caçar diploma viraria teletransporte.',
    salvarEstacao: 'Salvar estação',
    salvando: 'salvando…',
    sucesso: 'Estação no ar com a configuração nova.',
    erroSalvar: 'não foi possível salvar',
    erroServidor: 'não foi possível falar com o servidor',
  },
  waterfall: {
    semSinal: 'sem sinal',
    sinal: 'sinal',
    sinais: 'sinais',
    piso: 'piso',
    bandaSilenciosa: 'banda silenciosa',
    zoom: 'Zoom:',
    toqueParaTrocar: '— toque para trocar',
    farol: 'FAROL',
  },
  langSelector: {
    idioma: 'Idioma',
  },
} as const
